export default __webpack_public_path__ + "static/media/tab-blank-img.c5f54629.png";